import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Paper,
  Typography,
  IconButton,
  Grid,
  Box,
  TextField,
} from "@mui/material";
import { AddCircleOutline, Edit, Delete } from "@mui/icons-material";
import AddPortadas from "./panelPortadas/AddPortadas";
import { DeleteModal } from "./panelPortadas/DeleteModal";
import { useFetchSections } from "../../hooks/useGetSections";
import { useFetchPortadas } from "../../hooks/useGetPortadas";
import { Loading } from "../sharedComponents/Loading";
import { DataNotFound } from "../sharedComponents/DataNotFound";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  borderRadius: "10px",
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  height: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 12px 0px",
  cursor: "pointer",
  "&:hover": {
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    transform: "scale(1.05)",
    transition: "all 0.3s ease-in-out",
  },
}));

const ItemPortada = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  height: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
}));

export const PortadasPanel = ({ token, idDocument }) => {
  const [titleFilter, setTitleFilter] = useState("");
  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [selectedPortada, setSelectedPortada] = useState(null);
  const [modalDelete, setModalDelete] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const { sections, loadingSection } = useFetchSections(token, idDocument);
  const { portadas, loadingPortadas } = useFetchPortadas(token, refresh, idDocument);

  const handleDelete = (index) => {
    setDeleteIndex(index);
    setModalDelete(true);
  };

  const handleTitleChange = (event) => setTitleFilter(event.target.value);

  const filteredData = portadas.filter((item) =>
    item.titulo.toLowerCase().includes(titleFilter.toLowerCase())
  );

  const renderPortadas = () => {
    if (filteredData !== undefined) {
      return filteredData.map((portada, index) => (
        <Grid item xs={6} sm={4} md={3} key={index}>
          <ItemPortada
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "10px",
              margin: "5px",
            }}
          >
            <Typography
              variant="subtitle1"
              style={{ marginBottom: "5px", fontWeight: "700" }}
            >
              {portada.titulo}
            </Typography>
            <iframe
              src={portada.url}
              width="100%"
              height="180px"
              title="Visor PDF"
            ></iframe>
            {sections.find(
              (section) => section.ID_SECCION === portada.seccion_id
              )?.NOMBRE_SECCION || "Sección no encontrada"}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                marginTop: "10px",
              }}
            >
              <IconButton
                aria-label="edit"
                color="primary"
                onClick={() => {
                  setSelectedPortada(portada);
                  setModalEdit(true);
                }}
              >
                <Edit />
              </IconButton>
              <IconButton
                aria-label="delete"
                color="primary"
                onClick={() => handleDelete(portada.id)}
              >
                <Delete />
              </IconButton>
            </div>
          </ItemPortada>
        </Grid>
      ));
    }
  };

  return (
    <>
      {loadingSection ? (
        <Loading />
      ) : (
        <>
          <div style={{ height: "15%", width: "98%" }}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 4,
                pb: 3
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={6} sm={6} md={4}>
                  <TextField
                    label="Filtrar por Título"
                    variant="outlined"
                    value={titleFilter}
                    onChange={handleTitleChange}
                    fullWidth
                    sx={{
                      minWidth: 180,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={1} sm={1} md={5} />
                <Grid item xs={5} sm={5} md={3}>
                  <Item onClick={() => setModalAdd(true)}>
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: "16px",
                        color: "#235789",
                      }}
                    >
                      AGREGAR PORTADA
                    </div>
                    <IconButton aria-label="add" color="primary" size="small">
                      <AddCircleOutline sx={{ fontSize: 35 }} />
                    </IconButton>
                  </Item>
                </Grid>
              </Grid>
            </Box>
          </div>
          <div style={{ height: "84%", overflowY: "auto" }}>
            {loadingPortadas ? (
              <Loading />
            ) : filteredData.length === 0 ? (
              <DataNotFound />
            ) : (
              <Box
                sx={{
                  maxHeight: "650px",
                  padding: "10px",
                }}
              >
                <Grid container spacing={2}>{renderPortadas()}</Grid>
              </Box>
            )}
          </div>
        </>
      )}
      <AddPortadas
        token={token}
        open={modalAdd || modalEdit}
        close={() => {
          setModalAdd(false);
          setModalEdit(false);
          setSelectedPortada(null);
        }}
        initialPortadaData={selectedPortada}
        idDocument={idDocument}
        sections={sections}
        portadas={portadas}
        refresh={() => setRefresh(!refresh)}
      />
      <DeleteModal
        token={token}
        open={modalDelete}
        onClose={() => setModalDelete(false)}
        idCover={deleteIndex}
        refresh={() => setRefresh(!refresh)}
      />
    </>
  );
};
